import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function CTA() {
  const { t } = useLanguage();

  return (
    <section className="cta-v3">
      <motion.div
        className="cta-v3-inner"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="section-tag">{t('nav.contact')}</div>
        <h2 className="cta-v3-heading">
          {t('cta.line1')}<br />
          <span className="cta-v3-accent">{t('cta.line2')}</span>
        </h2>
        <Link to="/contact" className="btn btn-fill" style={{ fontSize: '13px', marginTop: '8px' }}>
          {t('nav.contact')} →
        </Link>
      </motion.div>
    </section>
  );
}
